import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const container = styled.div`
    flex-direction: column;
    justify-content: space-between;
    width: 100%
`;
export const ToogleButton = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    float: right;
    border: 0;
    cursor: pointer;

    font-size: ${theme.font.size16};
    font-weight: bold;
    color: ${(props) => props.theme.orangeLink};
    background-color: transparent;

    svg {
        margin-right: 8px;
    }
`;

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 960px) {
        flex-direction: column;
        align-items: end;
    }
`;

export const Row = styled.div`
    display: flex;
    gap: 24px;

    @media (max-width: 960px) {
        flex-direction: column;
        gap: 0;
        width: 100%;
    }
`;

export const FirstColumn = styled.div`
    margin: 0 24px 0 0;
    width: 100%;

    @media (max-width: 960px) {
        margin: 0;
    }

    ${({ showFilters }) => !showFilters && `display: none;`}
`;

export const SecondColumn = styled.div`
    display:flex;
    align-items:flex-end;
    margin: 0 0 24px 24px;

    @media (max-width: 960px) {
        width: 100%;
        
        & button {
            width: 100%;
        }
    }

    ${({ showFilters }) => !showFilters && `display: none;`}
`;

export const TextoUltimasFaturas = styled.div`
    display: flex;
    margin: 8px 32px 8px;
    font-size: ${theme.font.size20};
    font-weight: bold;
    color: ${(props) => props.theme.black};
    justify-content: space-between;
`;

export const TableContainer = styled.div`
    margin: 0 32px;

    .in-analysis-pending-move > td:not(.status-column) {
        color: #5B5B5F !important;
	    opacity: 0.4 !important;
    };

`;

export const SelectContainer = styled.div`
    display: flex;
    align-items: center;

    :first-child {
      flex: 1;
    }

    @media (max-width: 960px) {
        flex-direction: column;
        align-items: end;
    }
`;

export const LinkButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 5px;
    margin-bottom: 8px;
    margin-top: 8px;
    margin-left: 0;
    width: 100%;
    cursor: pointer;

    span {
        font-size: ${theme.font.size16};
        font-weight: bold;
        text-decoration: underline;
        color: ${(props) => props.theme.disabledGrey};
        cursor: not-allowed;
        width: max-content;

        &.active {
            color: ${(props) => props.theme.orangeLink};
            cursor: pointer;
        }
    }
`;

export const LinkButtonRegister = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 5px;
    margin-bottom: 8px;
    margin-top: 8px;
    margin-left: 0;
    width: 80%;
    cursor: pointer;

    span {
        font-size: ${theme.font.size16};
        font-weight: bold;
        text-decoration: underline;
        color: ${(props) => props.theme.disabledGrey};
        cursor: not-allowed;
        width: max-content;

        &.active {
            color: ${(props) => props.theme.orangeLink};
            cursor: pointer;
        }
    }
`;

export const CellWithIcon = styled.div`
    display: flex;
    gap: 0 5.5px;
    align-items: center;

    & span[class*="material-icons"] {
        cursor: pointer;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;

    margin: -100px 32px 0;

    button {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0 12px;
    }
`;

export const TooltipText = styled.div`
    font: ${theme.font.body[2]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
`;

export const ContainerRadio = styled.div`
    & .MuiFormControlLabel-root {
        width: ${({ columns }) => columns && `${Math.floor(100 / columns)}%`};
    }

    .MuiFormControlLabel-label {
        color: ${(props) => props.theme.black};
    }

    & .MuiTypography-root.MuiFormControlLabel-label.Mui-disabled div {
        color: ${({ contrastTheme, theme: styledTheme }) =>
            contrastTheme ? styledTheme.lightGrey20 : styledTheme.lightGreyLink40};
        cursor: not-allowed;
    }

    @media(min-width: 1024px) {
        div.MuiFormGroup-root {
            flex-direction: row;
        }
    }
`;
